// latest: zhangmyh 2017-10-16 2:30 PM

import { Model } from 'common'
Model.define('certification.sectionValueList', {
  meta: {
    endValue: '',
    score: '',
    startValue: '',
    ag_changed: ''
  }
})



// WEBPACK FOOTER //
// ./src/data/model/certification/sectionValueList.js